module.exports = "https://cdn.thelire.com/ins/resource/lh_alert_soldout.65385c4e3401f28e61ee134b6adbe946.png";